// import momenttz from "moment-timezone";
import { generateSlug } from "./generateSlug";
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const generateMatchSlug = (dataMatch) => {
  const matchDate = dayjs
    .unix(dataMatch.matchTime)
    .tz("Asia/Ho_Chi_Minh")
    .format("DD-MM-YYYY");
  return `${generateSlug(dataMatch.homeName)}-vs-${generateSlug(
    dataMatch.awayName
  )}-ngay-${matchDate}`;
};
